<template>
	<v-card elevation="0" class="top-divider py-2">
		<v-row class="ma-0" align-content="center" align="center">
			<v-toolbar-title class="text-body-1 pl-0"> 検索フォーム {{ count + 1 }} </v-toolbar-title>
			<v-row no-gutters justify="end">
				<v-menu offset-y close-on-click>
					<template v-slot:activator="{ on, attrs }">
						<v-btn text color="red" v-bind="attrs" v-on="on"> 削除 </v-btn>
					</template>
					<v-list>
						<v-list-item @click="$emit('delete-ledger-search-form')">
							<v-list-item-title color="red" class="text-body-2">本当に削除する</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>
				<v-btn icon color="primary" @click="showForm = !showForm">
					<v-icon color="secondary" v-if="!showForm">mdi-chevron-down</v-icon>
					<v-icon color="secondary" v-else-if="showForm">mdi-chevron-up</v-icon>
				</v-btn>
			</v-row>
		</v-row>
		<div v-show="showForm">
			<v-select
				v-if="associationNames.length"
				v-model="ledgerSearchForm.base_model"
				label="参照データ"
				:items="associationNames"
				class="mt-4"
				item-text="name"
				item-value="id"
				:persistent-hint="!ledgerSearchForm.base_model"
				hint="選択しなければ台帳の参照データの項目から項目名を選択できます。"
				clearable
				dense
				outlined
				@change="setColumnNames"
			/>
			<v-select
				v-model="ledgerSearchForm.column_name"
				ref="inputColumnName"
				label="項目名(必須)"
				:items="columnNameOptions"
				class="mt-4"
				item-text="name"
				item-value="id"
				:rules="[rules.required]"
				required
				dense
				outlined
				@change="changeColumnName"
			/>
			<v-select
				v-model="ledgerSearchForm.condition"
				ref="inputCondition"
				label="条件(必須)"
				:items="conditionOptions"
				item-text="name"
				item-value="id"
				class="mt-4"
				:rules="[rules.required]"
				no-data-text="項目名を選択してください"
				dense
				outlined
				@change="changeCondition"
			/>
			<v-select
				v-model="ledgerSearchForm.form_type"
				label="入力フォームタイプ(必須)"
				ref="inputFormType"
				:items="formTypeOptions"
				class="mt-4"
				item-text="name"
				item-value="id"
				:rules="[rules.required]"
				no-data-text="条件を選択してください"
				required
				dense
				outlined
				@change="changeFormType"
			/>
			<div v-if="showOptionBtn">
				<v-row no-gutters class="pb-2" justify="end">
					<v-btn color="secondary" @click="addSearchOption">
						<v-icon class="mr-2">mdi-format-list-group-plus</v-icon>
						選択項目を追加</v-btn
					>
				</v-row>
			</div>
			<div>
				<LedgerSearchOptionForm
					v-for="(searchOption, i) in filteredArray"
					:ledgerSearchOptionData="searchOption"
					:valueOptions="valueOptions"
					:columnType="columnType"
					:key="searchOption.uuid"
					@delete-ledger-search-option="deleteSearchOption(i)"
					@change-ledger-search-option="changeSearchOption($event, i)"
				/>
			</div>
		</div>
	</v-card>
</template>
<script>
import rules from "../../../helper/rules"
import LedgerSearchOptionForm from "./LedgerSearchOptionForm.vue"

export default {
	components: {
		LedgerSearchOptionForm,
	},
	props: {
		ledgerSearchFormData: Object,
		searchOptions: Object,
		originalModelColumns: Array,
		associationNames: Array,
		count: Number,
	},
	data() {
		return {
			ledgerSearchForm: {
				uuid: null,
				base_model: null,
				column_name: null,
				condition: null,
				form_type: null,
				ledger_search_options_attributes: [],
			},
			deletedAttributes: {
				ledger_search_options: [],
			},
			rules: rules,
			showForm: true,
			selectedModel: null,
			columnType: null,
			selectedColumnName: null,
			valueOptions: [],
			menu: false,
		}
	},
	mounted() {
		this.ledgerSearchForm = this.ledgerSearchFormData
		this.$refs.inputColumnName.resetValidation()
		this.$refs.inputCondition.resetValidation()
		this.$refs.inputFormType.resetValidation()
		if (this.ledgerSearchForm.base_model) this.setColumnOption()
		if (this.ledgerSearchForm.column_name) this.setColumnType()
	},
	methods: {
		emptyAttributes() {
			const savedSearchOptions = this.ledgerSearchForm.ledger_search_options_attributes.filter(
				(searchOption) => searchOption.id
			)
			this.ledgerSearchForm.ledger_search_options_attributes = savedSearchOptions.map(
				(searchOption) => ({ id: searchOption.id, _destroy: true })
			)
		},
		setColumnNames() {
			this.columnType = null
			this.valueOptions = []
			this.ledgerSearchForm.column_name = null
			this.ledgerSearchForm.condition = null
			this.ledgerSearchForm.form_type = null
			if (this.filteredArray.length) {
				this.emptyAttributes()
			}
			this.setColumnOption()
			this.$refs.inputColumnName.resetValidation()
			this.$refs.inputCondition.resetValidation()
			this.$refs.inputFormType.resetValidation()
			this.changeLedgerSearchForm()
		},
		setColumnOption() {
			this.selectedModel = this.associationNames.find(
				(model) => this.ledgerSearchForm.base_model == model.id
			)
		},
		changeColumnName() {
			this.columnType = null
			this.valueOptions = []
			this.ledgerSearchForm.condition = null
			this.ledgerSearchForm.form_type = null
			if (this.filteredArray.length) {
				this.emptyAttributes()
			}
			this.setColumnType()
			this.$refs.inputCondition.resetValidation()
			this.$refs.inputFormType.resetValidation()
			this.changeLedgerSearchForm()
		},
		setColumnType() {
			this.selectedColumnName = this.columnNameOptions.find(
				(c) => c.id == this.ledgerSearchForm.column_name
			)
			if (this.selectedColumnName) {
				this.columnType = this.selectedColumnName.type
				this.valueOptions = this.selectedColumnName.options
			}
		},
		changeCondition() {
			this.ledgerSearchForm.form_type = null
			if (this.filteredArray.length) {
				this.emptyAttributes()
			}
			this.$refs.inputFormType.resetValidation()
			this.changeLedgerSearchForm()
		},
		changeFormType() {
			if (this.filteredArray.length) {
				this.emptyAttributes()
			}
			this.changeLedgerSearchForm()
		},
		changeLedgerSearchForm() {
			this.$emit("change-ledger-search-form", this.ledgerSearchForm)
		},
		addSearchOption() {
			const newSearchOption = {
				uuid: this.newUuid(),
				name: null,
				value_string: null,
				value_boolean: null,
				value_integer: null,
				value_float: null,
			}
			this.ledgerSearchForm.ledger_search_options_attributes.push(newSearchOption)
		},
		deleteSearchOption(i) {
			const searchOption = this.filteredArray[i]
			i = this.ledgerSearchForm.ledger_search_options_attributes.indexOf(searchOption)
			if (searchOption.id) {
				this.ledgerSearchForm.ledger_search_options_attributes.push({
					id: searchOption.id,
					_destroy: true,
				})
			}
			this.ledgerSearchForm.ledger_search_options_attributes.splice(i, 1)
			this.changeLedgerSearchForm()
		},
		changeSearchOption(searchOption, i) {
			this.filteredArray[i] = searchOption
			this.changeLedgerSearchForm()
		},
		newUuid() {
			return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
				(c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
			)
		},
	},
	computed: {
		columnNameOptions() {
			if (this.selectedModel) {
				return this.selectedModel.columns.filter((c) => !c.meta_tag)
			} else {
				return this.originalModelColumns.filter((c) => !c.meta_tag)
			}
		},
		conditionOptions() {
			if (!this.selectedColumnName) return []
			if (this.selectedColumnName.options.length && this.columnType != "boolean") {
				return this.searchOptions.conditions.enum
			}
			switch (this.columnType) {
				case "integer":
				case "float":
					return this.searchOptions.conditions.number
				case "string":
				case "text":
					return this.searchOptions.conditions.text
				case "date":
				case "datetime":
					return this.searchOptions.conditions.date
				case "boolean":
					return this.searchOptions.conditions.boolean
				default:
					return []
			}
		},
		showOptionBtn() {
			const requireChoices = ["select", "multi_select", "checkbox", "radio"]
			return (
				requireChoices.includes(this.ledgerSearchForm.form_type) &&
				this.columnType != "boolean" &&
				!["_present", "_blank", "_null", "_not_null", "_true", "_false"].includes(
					this.ledgerSearchForm.condition
				)
			)
		},
		// リファクタリング推奨
		formTypeOptions() {
			const singleChoiceForm = ["text", "number", "select", "radio"]
			const multiChoiceForm = ["multi_select", "checkbox"]
			const booleanChoice = ["_present", "_blank", "_null", "_not_null", "_true", "_false"]
			const singleChoice = [
				"_eq",
				"_not_eq",
				"_lt",
				"_lteq",
				"_gt",
				"_gteq",
				"_start",
				"_not_start",
				"_end",
				"_not_end",
				"_cont",
				"_not_cont",
			]
			const multiChoice = [
				"_in",
				"_not_in",
				"_cont_any",
				"_cont_all",
				"_not_cont_any",
				"_not_cont_all",
			]
			if (booleanChoice.includes(this.ledgerSearchForm.condition)) {
				return this.searchOptions.form_types.filter((f) => f.id == "radio")
			} else if (this.columnType == "date" || this.columnType == "datetime") {
				return this.searchOptions.form_types.filter((f) => f.id == "date")
			} else if (
				this.valueOptions.length &&
				singleChoice.includes(this.ledgerSearchForm.condition)
			) {
				return this.searchOptions.form_types.filter((f) => f.id == "select" || f.id == "radio")
			} else if (singleChoice.includes(this.ledgerSearchForm.condition)) {
				return this.searchOptions.form_types.filter((f) => singleChoiceForm.includes(f.id))
			} else if (multiChoice.includes(this.ledgerSearchForm.condition)) {
				return this.searchOptions.form_types.filter((f) => multiChoiceForm.includes(f.id))
			} else {
				return []
			}
		},
		filteredArray() {
			return this.ledgerSearchForm.ledger_search_options_attributes.filter(
				(searchOption) => !searchOption._destroy
			)
		},
	},
	watch: {
		ledgerSearchFormData(newValue, _) {
			this.ledgerSearchForm = newValue
		},
		deep: true,
	},
}
</script>

<style scoped lang="scss">
@import "../../../stylesheet/shared/color.scss";
.ledger-search-form {
	padding: 8px;
	&:not(:first-child) {
		border-top: 1px solid whitesmoke;
	}
}
.v-toolbar__content {
	padding: 0;
}
</style>